import axios from "axios";
import { useQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const attribute = async (id?: number) => axios.get(Routes.ATTRIBUTE + "/" + id);

export const useAttribute = (id?: number) =>
  useQuery({
    queryKey: [Keys.ATTRIBUTE_QRY, id],
    queryFn: () => attribute(id),
    enabled: id !== undefined && id !== null ? true : false,
  });
